var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", { staticClass: "header" }, [_c("HeaderComponent")], 1),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("SideBarComponent"),
          _vm._v(" "),
          _c(
            "el-main",
            { staticClass: "main ai_main video_main" },
            [
              _vm.global.type == "client"
                ? _c("SubTitleComponent", { attrs: { title: _vm.title } })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box" },
                [
                  _vm.global.type == "manage"
                    ? _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c("el-col", { attrs: { span: 3 } }, [
                            _c("h4", [_vm._v("选择客户")])
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  on: { change: _vm.customerChange },
                                  model: {
                                    value: _vm.customerValue,
                                    callback: function($$v) {
                                      _vm.customerValue = $$v
                                    },
                                    expression: "customerValue"
                                  }
                                },
                                _vm._l(_vm.customerData, function(item) {
                                  return _c("el-option", {
                                    key: item.number,
                                    attrs: {
                                      label: item.number + item.client_name,
                                      value: item.client_name
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-radio-group",
                    {
                      on: { input: _vm.AiTypeChange },
                      model: {
                        value: _vm.aiType,
                        callback: function($$v) {
                          _vm.aiType = $$v
                        },
                        expression: "aiType"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "ai_type_box" },
                        [
                          _c("el-radio-button", {
                            attrs: { label: "单图生成" }
                          }),
                          _vm._v(" "),
                          _c("el-radio-button", {
                            attrs: { label: "首尾帧生成" }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "img_bg" },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c("el-col", { attrs: { span: 6 } }, [
                            _vm.aiType == "单图生成"
                              ? _c(
                                  "div",
                                  { staticClass: "upload_box" },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          "show-file-list": false,
                                          multiple: "",
                                          "http-request": _vm.uploadImage
                                        }
                                      },
                                      [
                                        _vm.uploadImg
                                          ? _c(
                                              "div",
                                              { staticClass: "img_box" },
                                              [
                                                _c("img", {
                                                  attrs: { src: _vm.uploadImg }
                                                })
                                              ]
                                            )
                                          : _c("el-button", {
                                              attrs: { icon: "el-icon-plus" }
                                            })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.uploadImg
                                      ? _c(
                                          "div",
                                          { staticClass: "btn upload" },
                                          [
                                            _c(
                                              "el-upload",
                                              {
                                                staticClass: "upload-demo",
                                                attrs: {
                                                  action: "",
                                                  "show-file-list": false,
                                                  multiple: "",
                                                  "http-request":
                                                    _vm.uploadImage
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-upload2"
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.uploadImg
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "btn delete",
                                            on: {
                                              click: function($event) {
                                                return _vm.deleteUpload(0)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-delete"
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.aiType == "首尾帧生成"
                              ? _c("div", {}, [
                                  _c(
                                    "div",
                                    {
                                      class: [
                                        "upload_box upload_box2",
                                        _vm.shouWeiCur == 0 ? "on" : ""
                                      ]
                                    },
                                    [
                                      _c(
                                        "el-upload",
                                        {
                                          staticClass: "upload-demo",
                                          attrs: {
                                            action: "",
                                            "show-file-list": false,
                                            multiple: "",
                                            "http-request": _vm.uploadImage1
                                          }
                                        },
                                        [
                                          _vm.uploadImgF
                                            ? _c(
                                                "div",
                                                { staticClass: "img_box" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.uploadImgF
                                                    }
                                                  })
                                                ]
                                              )
                                            : _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    icon: "el-icon-plus"
                                                  }
                                                },
                                                [_vm._v("首帧")]
                                              )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.uploadImgF
                                        ? _c(
                                            "div",
                                            { staticClass: "btn upload" },
                                            [
                                              _c(
                                                "el-upload",
                                                {
                                                  staticClass: "upload-demo",
                                                  attrs: {
                                                    action: "",
                                                    "show-file-list": false,
                                                    multiple: "",
                                                    "http-request":
                                                      _vm.uploadImage1
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-upload2"
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.uploadImgF
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "btn delete",
                                              on: {
                                                click: function($event) {
                                                  return _vm.deleteUpload(1)
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-delete"
                                              })
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      class: [
                                        "upload_box upload_box2",
                                        _vm.shouWeiCur == 1 ? "on" : ""
                                      ]
                                    },
                                    [
                                      _c(
                                        "el-upload",
                                        {
                                          staticClass: "upload-demo",
                                          attrs: {
                                            action: "",
                                            "show-file-list": false,
                                            multiple: "",
                                            "http-request": _vm.uploadImage2
                                          }
                                        },
                                        [
                                          _vm.uploadImgE
                                            ? _c(
                                                "div",
                                                { staticClass: "img_box" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.uploadImgE
                                                    }
                                                  })
                                                ]
                                              )
                                            : _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    icon: "el-icon-plus"
                                                  }
                                                },
                                                [_vm._v("尾帧")]
                                              )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.uploadImgE
                                        ? _c(
                                            "div",
                                            { staticClass: "btn upload" },
                                            [
                                              _c(
                                                "el-upload",
                                                {
                                                  staticClass: "upload-demo",
                                                  attrs: {
                                                    action: "",
                                                    "show-file-list": false,
                                                    multiple: "",
                                                    "http-request":
                                                      _vm.uploadImage2
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-upload2"
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.uploadImgE
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "btn delete",
                                              on: {
                                                click: function($event) {
                                                  return _vm.deleteUpload(2)
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-delete"
                                              })
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 18 } }, [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "infinite-scroll",
                                    rawName: "v-infinite-scroll",
                                    value: _vm.getSlide,
                                    expression: "getSlide"
                                  }
                                ],
                                staticClass: "slide_box",
                                attrs: { "infinite-scroll-distance": "100" }
                              },
                              [
                                _c(
                                  "waterfall",
                                  {
                                    staticClass: "slide_main",
                                    attrs: {
                                      col: 5,
                                      gutterWidth: 20,
                                      data: _vm.slideData,
                                      lazyDistance: 200,
                                      loadDistance: 100
                                    },
                                    on: { loadmore: _vm.getSlide }
                                  },
                                  [
                                    _vm._l(_vm.slideData, function(
                                      item,
                                      index
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: "meterial" + index,
                                          staticClass: "item"
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src:
                                                item.photo_url +
                                                "?x-oss-process=image/resize,w_300",
                                              alt: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.toDetail(index)
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "radio",
                                              on: {
                                                click: function($event) {
                                                  return _vm.slideClick(index)
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "el-radio",
                                                {
                                                  attrs: { label: index },
                                                  model: {
                                                    value: _vm.slideCur,
                                                    callback: function($$v) {
                                                      _vm.slideCur = $$v
                                                    },
                                                    expression: "slideCur"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.space_type +
                                                        String(index + 1)
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-divider", { attrs: { "content-position": "left" } }, [
                    _vm._v("运镜方式")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.cameraCur,
                        callback: function($$v) {
                          _vm.cameraCur = $$v
                        },
                        expression: "cameraCur"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "camera_box" },
                        _vm._l(_vm.cameraData, function(item, index) {
                          return _c(
                            "div",
                            { key: "camera" + index, staticClass: "item" },
                            [
                              _c("img", { attrs: { src: item.img, alt: "" } }),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: index } }, [
                                _vm._v(_vm._s(item.name))
                              ])
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("el-divider", { attrs: { "content-position": "left" } }, [
                    _vm._v("补充描述")
                  ]),
                  _vm._v(" "),
                  _c("div", {}, [
                    _c("div", { staticClass: "ai_para_box" }, [
                      _c("div", { staticClass: "cue_word" }, [
                        _c(
                          "div",
                          { staticClass: "item" },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "textarea",
                                rows: 5,
                                placeholder: "请输入内容",
                                resize: "none"
                              },
                              model: {
                                value: _vm.zh_content,
                                callback: function($$v) {
                                  _vm.zh_content = $$v
                                },
                                expression: "zh_content"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("el-divider", { attrs: { "content-position": "left" } }, [
                    _vm._v("AI大模型")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {},
                    [
                      _c(
                        "el-radio-group",
                        {
                          on: { input: _vm.aiChange },
                          model: {
                            value: _vm.aiCur,
                            callback: function($$v) {
                              _vm.aiCur = $$v
                            },
                            expression: "aiCur"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "ai_box" },
                            _vm._l(_vm.aiData, function(item, index) {
                              return _c(
                                "el-radio",
                                {
                                  key: "ai" + index,
                                  attrs: { label: item.model_id }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      item.model_name + "(" + item.price + ")"
                                    )
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-divider", { attrs: { "content-position": "left" } }, [
                    _vm._v("视频时长")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.durationCur,
                        callback: function($$v) {
                          _vm.durationCur = $$v
                        },
                        expression: "durationCur"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "duration_box" },
                        _vm._l(_vm.durationData, function(item, index) {
                          return _c(
                            "el-radio",
                            {
                              key: "duration" + index,
                              attrs: { label: index }
                            },
                            [_vm._v(_vm._s(item + "s"))]
                          )
                        }),
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "btn_save" },
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { type: "success" },
                          on: { click: _vm.onSubmit }
                        },
                        [_vm._v("立即生成")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "prompt" }, [
                        _vm._v(
                          "（本月剩余使用额度 " +
                            _vm._s(_vm.global.money) +
                            "元）"
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.resultStatus != 0
                    ? _c("div", { staticClass: "effect_box" }, [
                        _vm.resultStatus == 2
                          ? _c("div", { staticClass: "complete" }, [
                              _c("div", { staticClass: "cur" }, [
                                _c("video", {
                                  ref: "videoPlayer",
                                  attrs: {
                                    src: _vm.effectData[0].file_url,
                                    alt: "",
                                    poster: _vm.posterImg,
                                    controls: _vm.isPlaying
                                  },
                                  on: {
                                    pause: _vm.onVideoPause,
                                    ended: _vm.onVideoEnded
                                  }
                                }),
                                _vm._v(" "),
                                _vm.isPlaying == false
                                  ? _c("div", {
                                      staticClass: "play",
                                      on: { click: _vm.toPlay }
                                    })
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "tools" }, [
                                _c(
                                  "div",
                                  { staticClass: "btn" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "success",
                                          icon:
                                            _vm.favoriteType == true
                                              ? "el-icon-star-off"
                                              : "el-icon-star-on"
                                        },
                                        on: { click: _vm.toFavorite }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.favoriteType == true
                                              ? "收藏"
                                              : "取消收藏"
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {},
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "success",
                                          icon: "el-icon-download"
                                        },
                                        on: { click: _vm.toDownload }
                                      },
                                      [_vm._v("下载")]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resultStatus == 1
                          ? _c(
                              "div",
                              { staticClass: "progress" },
                              [
                                _c("el-progress", {
                                  attrs: { percentage: _vm.percent }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    visible: _vm.dialogVisit,
                    top: "15vh",
                    "show-close": false,
                    center: true
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogVisit = $event
                    }
                  }
                },
                [
                  _vm.dialogCur != -1
                    ? _c("div", { staticClass: "img" }, [
                        _c("img", { attrs: { src: _vm.detailImg, alt: "" } })
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-80d825d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80d825d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Effect/Video.vue
// module id = null
// module chunks = 